import { GET_INVOICEWISE_PAYMENT_BREAKUP_REPORT, RESET_GET_INVOICEWISE_PAYMENT_BREAKUP_REPORT } from '../../../Types'

const InvoiceWisePaymentBreakupReducer = (state = [], action) => {
    switch (action.type) {
        case GET_INVOICEWISE_PAYMENT_BREAKUP_REPORT:
            return action.payload
        case RESET_GET_INVOICEWISE_PAYMENT_BREAKUP_REPORT:
            return action.payload
        default:
            return state
    }
}
export default InvoiceWisePaymentBreakupReducer